import { render, staticRenderFns } from "./consulta_pets_paciente.vue?vue&type=template&id=26cb272e&scoped=true&"
import script from "./consulta_pets_paciente.vue?vue&type=script&lang=js&"
export * from "./consulta_pets_paciente.vue?vue&type=script&lang=js&"
import style0 from "./consulta_pets_paciente.vue?vue&type=style&index=0&id=26cb272e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cb272e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDataTable,VDialog,VIcon,VSpacer,VTextField,VToolbar})
